module.exports = __webpack_public_path__ + "static/media/refer3.a69f655d.png";